module.exports = __webpack_public_path__ + "static/zebrarecycledmain-2f328a2391bdb0358ffebcadecc82beb.png";